/* eslint-disable indent */
import styled from 'styled-components';

export const List = styled.div`
    display: grid;
    gap: .4em;
    margin: .4em 1px 0 1px;
    padding: 0;
    text-align: left;

    .btn-container {
        line-height: 1;
        .btn_show-all {
            padding: .4em .5em;
            width: auto;
            min-width: 36px;
        }
        .inx-fa-icon {
            margin-right: .4em;
        }
    }
`;

export const StyledPrintList = styled.ul`
    line-height: 1.4;
    ${({ theme }) => `
        font-size: ${theme.fontSize}px;
        padding: .4em;
        margin-bottom: -.4em;
    `};
    li {
        display: inline;
        :not(:last-child) {
            ${({ theme }) => ` margin-right: ${theme.gridGutterWidth}px;`}
        }
    }
    .inx-fa-icon {
        color: var(--color-gray-500);
        display: inline-block;
        margin-right: 2px;
        vertical-align: text-bottom;
    }
`;

export const Pane = styled.div`
    ${List} {
        ${({ theme, $isOpen }) => {
            const btnCol = $isOpen ? '' : 'min-content';
            return `
                grid-template-columns: repeat(${theme.data.cols}, minmax(100px, 1fr)) ${btnCol};
            `;
        }}
    }
`;